import { queryLogList } from "../../api/config/modules/OperationLog";

const state = {
  queryLogList: {},
};

const mutations = {
  SET_QUERYLOGLIST: (state, queryLogList) => {
    state.queryLogList = queryLogList;
  },
};

const actions = {
  GET_QUERYLOGLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryLogList(data)
        .then((res) => {
          commit("SET_QUERYLOGLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
